export const ADD_SKU_SINGLE = "ADD_SKU_SINGLE";
export const ADD_SKU_BULK = "ADD_SKU_BULK";
export const REMOVE_SKU_SINGLE = "REMOVE_SKU_SINGLE";
export const REMOVE_SKU_BULK = "REMOVE_SKU_BULK";
export const EXECUTION_START = "EXECUTION_START";
export const EXECUTION_SUCCESS = "EXECUTION_SUCCESS";
export const EXECUTION_FAIL = "EXECUTION_FAIL";
export const SET_ACCOUNT = "SET_ACCOUNT";
